export const getPriorityBadgeClass = (priority) => {
  const map = {
    high: "badge bg-danger-subtle text-danger border badge-priority",
    medium: "badge bg-warning-subtle text-warning border badge-priority",
    low: "badge bg-success-subtle text-success border badge-priority",
  };

  return (
    map[priority?.toLowerCase()] ||
    "badge bg-secondary-subtle text-secondary border badge-priority"
  );
};

export const getStatusBadgeClass = (status) => {
  const map = {
    pending: "badge bg-warning-subtle text-warning border badge-status",
    "in review": "badge bg-secondary-subtle text-secondary border badge-status",
    approved: "badge bg-success-subtle text-success border badge-priority",
    rejected: "badge bg-danger-subtle text-danger border badge-priority",
  };

  return (
    map[status?.toLowerCase()] ||
    "badge bg-secondary-subtle text-secondary border badge-status"
  );
};

// // badgeUtils.js
// export { getPriorityBadgeClass } from "./priority";
// export { getStatusBadgeClass } from "./status";
// export { getPlanBadgeClass } from "./plan";
// export { getVerificationBadgeClass } from "./verification";
